// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"2348":"chat","2443":"about"}[chunkId] || chunkId) + "." + {"2348":"9d944653","2443":"94c092bf","6780":"771d184b"}[chunkId] + ".css";
};